/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import type { Bootstrap } from '../types.tsx';

const bootstrap: Bootstrap =
	() =>
	({ setState, getState }, { getMeta }) => {
		if (getState().tenantContext) return;
		const tenantContext = getTenantContext_DEPRECATED_DO_NOT_USE(getMeta);
		setState({ tenantContext });
	};

export { bootstrap };
